module.exports = __webpack_public_path__ + "img/icon_employees_pt.1f1f2528.png";